

var xlsx = require('xlsx');
function getExcelSheet(_this,missing_master_data,refs,master_type){
    console.log("dfsd");
    //Read the Excel File data.
    fetch('/Sheets/ledger.xlsx').then(res => { 
        return res.arrayBuffer();
    }).then(res => {
        var workbook = xlsx.read(new Uint8Array(res), {
            type: 'array'
        });
        var data =massage(workbook);
        $.each(missing_master_data, function (key, value) {
            var text = value.name;
            var cells = [{ text }];
            data[0].rows[key + 1] = { cells }
        })
        _this.missing_data_var=data;
        refs.setDataInExcel(_this.missing_data_var,master_type);
        _this.showModal();
    });
   // _this.data = massage(wb);
}

//function for reading excel files
const massage = wb => {
    const out = [];
    wb.SheetNames.forEach(name => {
        const o = { name, rows: {} };
        const ws = wb.Sheets[name];
        const aoa = xlsx.utils.sheet_to_json(ws, { raw: false, header: 1 });
        aoa.forEach((r, i) => {
            const cells = {};
            r.forEach((c, j) => {
                cells[j] = { text: c };
            });
            o.rows[i] = {
                cells
            };
        });
        out.push(o);
    });
    return out;
};
//read function ends

export{getExcelSheet}